export const initializeHeader = () => {
    const header = document.querySelector("[data-site-header]");
    if (!header) {
        return;
    }
    const menuToggle = header.querySelector("[data-nav-toggle]");
    const mobileNavigation = document.querySelector("[data-mobile-navigation]");
    const mobileNavigationLinks = mobileNavigation
        ? [
            ...mobileNavigation.querySelectorAll("a"),
        ]
        : [];
    const announcementsWrapper = header.querySelector("[data-header-announcements]");
    const SCROLL_THRESHOLD = 8;
    const HIDE_AFTER = 120;
    const MOBILE_BREAKPOINT = 900;
    const AUTOPLAY_DELAY = 6000;
    let lastScrollY = window.scrollY;
    let ticking = false;
    /**
     * HEADER HEIGHT
     */
    const updateHeaderHeight = () => {
        document.documentElement.style.setProperty("--site-header-height", `${header.offsetHeight}px`);
    };
    /**
     * MOBILE MENU
     */
    const isMenuOpen = () => {
        return mobileNavigation?.classList.contains("mobile-navigation--open");
    };
    const setMenuOpen = (open) => {
        if (!mobileNavigation) {
            return;
        }
        mobileNavigation.inert = !open;
        mobileNavigation.classList.toggle("mobile-navigation--open", open);
        document.body.classList.toggle("site-menu-open", open);
        mobileNavigation.setAttribute("aria-hidden", String(!open));
        menuToggle?.setAttribute("aria-expanded", String(open));
        menuToggle?.setAttribute("aria-label", open
            ? "Close menu"
            : "Open menu");
        header.classList.toggle("site-header--menu-open", open);
        if (open) {
            header.classList.remove("site-header--hidden");
        }
    };
    menuToggle?.addEventListener("click", () => {
        setMenuOpen(!isMenuOpen());
    });
    mobileNavigationLinks.forEach((link) => {
        link.addEventListener("click", () => {
            setMenuOpen(false);
        });
    });
    document.addEventListener("keydown", (event) => {
        if (event.key === "Tab" && isMenuOpen() && menuToggle) {
            const controls = [menuToggle, ...mobileNavigationLinks];
            const first = controls[0];
            const last = controls[controls.length - 1];
            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last?.focus();
            }
            else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first?.focus();
            }
        }
        if (event.key === "Escape"
            && isMenuOpen()) {
            setMenuOpen(false);
            menuToggle?.focus();
        }
    });
    /**
     * HEADER SCROLL
     */
    const updateHeaderOnScroll = () => {
        const currentScrollY = Math.max(window.scrollY, 0);
        header.classList.toggle("site-header--scrolled", currentScrollY > 0);
        if (currentScrollY <= HIDE_AFTER
            || isMenuOpen()) {
            header.classList.remove("site-header--hidden");
            lastScrollY = currentScrollY;
            return;
        }
        const difference = currentScrollY - lastScrollY;
        if (Math.abs(difference)
            < SCROLL_THRESHOLD) {
            return;
        }
        if (difference > 0) {
            header.classList.add("site-header--hidden");
        }
        else {
            header.classList.remove("site-header--hidden");
        }
        lastScrollY = currentScrollY;
    };
    window.addEventListener("scroll", () => {
        if (ticking) {
            return;
        }
        ticking = true;
        window.requestAnimationFrame(() => {
            updateHeaderOnScroll();
            ticking = false;
        });
    }, {
        passive: true,
    });
    /**
     * ANNOUNCEMENTS
     */
    if (announcementsWrapper) {
        const announcements = [
            ...announcementsWrapper.querySelectorAll("[data-header-announcement]"),
        ];
        const previousButton = announcementsWrapper.querySelector("[data-header-announcement-prev]");
        const nextButton = announcementsWrapper.querySelector("[data-header-announcement-next]");
        if (announcements.length > 1) {
            let activeIndex = 0;
            let autoplayId = null;
            const showAnnouncement = (index) => {
                activeIndex =
                    (index
                        + announcements.length)
                        % announcements.length;
                announcements.forEach((announcement, announcementIndex) => {
                    const active = announcementIndex
                        === activeIndex;
                    announcement.classList.toggle("site-header__announcement--active", active);
                    announcement.setAttribute("aria-hidden", String(!active));
                    announcement.tabIndex =
                        active ? 0 : -1;
                });
            };
            const next = () => {
                showAnnouncement(activeIndex + 1);
            };
            const previous = () => {
                showAnnouncement(activeIndex - 1);
            };
            const stopAutoplay = () => {
                if (autoplayId === null) {
                    return;
                }
                window.clearInterval(autoplayId);
                autoplayId = null;
            };
            const startAutoplay = () => {
                stopAutoplay();
                autoplayId =
                    window.setInterval(next, AUTOPLAY_DELAY);
            };
            previousButton?.addEventListener("click", () => {
                previous();
                startAutoplay();
            });
            nextButton?.addEventListener("click", () => {
                next();
                startAutoplay();
            });
            announcementsWrapper.addEventListener("mouseenter", stopAutoplay);
            announcementsWrapper.addEventListener("mouseleave", startAutoplay);
            showAnnouncement(0);
            startAutoplay();
        }
    }
    /**
     * RESIZE
     */
    window.addEventListener("resize", () => {
        updateHeaderHeight();
        if (window.innerWidth
            > MOBILE_BREAKPOINT
            && isMenuOpen()) {
            setMenuOpen(false);
        }
    });
    setMenuOpen(false);
    new ResizeObserver(updateHeaderHeight).observe(header);
    updateHeaderHeight();
    updateHeaderOnScroll();
};
